import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "bg"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  id: "bdmap",
  class: "bdmap",
  ref: "bdmap"
};
const _hoisted_6 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_mapv2assembly = _resolveComponent("mapv2assembly");
  const _component_typev2 = _resolveComponent("typev2");
  const _component_mappopupv2 = _resolveComponent("mappopupv2");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["mapContainer", {
      'isMobile': $props.isMobile
    }]),
    style: _normalizeStyle($data.mainStyle)
  }, [_createElementVNode("div", {
    class: _normalizeClass(`formUserId${$data.formUserId}`),
    style: {
      "width": "100%",
      "height": "100%",
      "position": "relative"
    }
  }, [_withDirectives(_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
    src: $data.mapelem.bg
  }, null, 8, _hoisted_2)], 512), [[_vShow, $data.mapelem.bg !== '']]), _withDirectives(_createElementVNode("div", {
    class: "logo",
    style: _normalizeStyle($data.modulestyle.logo)
  }, [_createElementVNode("img", {
    src: $data.mapelem.logo
  }, null, 8, _hoisted_3)], 4), [[_vShow, $data.mapelem.logo !== '']]), _withDirectives(_createElementVNode("div", {
    class: "pickey",
    style: _normalizeStyle($data.modulestyle.pickey)
  }, [_createElementVNode("img", {
    src: $data.mapelem.pickey
  }, null, 8, _hoisted_4)], 4), [[_vShow, $data.mapelem.pickey !== '']]), $data.loadingmap ? (_openBlock(), _createBlock(_component_mapv2assembly, {
    key: 0,
    ref: "mapv2assembly",
    id: $props.id,
    showgdtilelayer: $data.mapLayers.tiles,
    showgeojsonlayer: $data.mapLayers.json,
    showstaticlayer: $data.mapLayers.static,
    staticimage: $data.mapLayers.staticimage,
    drawelement: $data.mapLayers.drawelement,
    geojson: $data.mapLayers.geojson,
    mapstyle: $data.mapstyle,
    adcode: $data.mapview.adcode,
    zoom: $data.mapview.zoom,
    minZoom: $data.mapview.minZoom,
    maxZoom: $data.mapview.maxZoom,
    extent: $data.mapview.extent,
    center: $data.mapview.center,
    scale: $data.mapview.scale,
    rotate: $data.mapview.rotate,
    translate: $data.mapview.translate,
    streetcode: $data.mapstreetcode,
    pointlist: $data.pointList,
    culturallist: $data.mapyujipointList,
    isMobile: $data.isMobileflag,
    onSingleclick: $options.singleclick,
    onMarkerclick: $options.markerclick,
    onMarkermoveend: $options.markermoveend,
    onDrawarea: $options.drawarea
  }, null, 8, ["id", "showgdtilelayer", "showgeojsonlayer", "showstaticlayer", "staticimage", "drawelement", "geojson", "mapstyle", "adcode", "zoom", "minZoom", "maxZoom", "extent", "center", "scale", "rotate", "translate", "streetcode", "pointlist", "culturallist", "isMobile", "onSingleclick", "onMarkerclick", "onMarkermoveend", "onDrawarea"])) : _createCommentVNode("", true), _createVNode(_component_typev2, {
    modeltype: $data.modeltype,
    typeshowflag: $data.form.showtype,
    typelist: $data.typeList,
    typebtnstyle: $data.typebtn,
    posstyle: $data.modulestyle.type,
    showtypeall: $data.mapstyle.typeall,
    typeallname: $data.mapstyle.typeallname,
    onTypeselect: $options.typeselect
  }, null, 8, ["modeltype", "typeshowflag", "typelist", "typebtnstyle", "posstyle", "showtypeall", "typeallname", "onTypeselect"]), _createVNode(_component_mappopupv2, {
    detail: $data.pointdetail,
    popshowflag: $data.popshowflag,
    modeltype: $data.popmodeltype,
    isMobile: $data.isMobileflag,
    onCloseHandle: $options.closeHandle,
    onAtlasmarkerclick: $options.atlasmarkerclick
  }, null, 8, ["detail", "popshowflag", "modeltype", "isMobile", "onCloseHandle", "onAtlasmarkerclick"]), _createElementVNode("div", _hoisted_5, null, 512)], 2), _createVNode(_component_el_dialog, {
    modelValue: $data.dialogVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.dialogVisible = $event),
    title: "编辑区域列表",
    width: "220",
    top: "0",
    "append-to-body": true,
    modal: false
  }, {
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
      onClick: $options.quitPointHandle
    }, {
      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("预览", -1)]))]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_el_button, {
      type: "primary",
      onClick: $options.confirmPointHandle
    }, {
      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("保存", -1)]))]),
      _: 1
    }, 8, ["onClick"])])]),
    _: 1
  }, 8, ["modelValue"])], 6);
}